import { create } from "zustand";

interface UiState {
  isCouponSheetOpen: boolean;
  setCouponSheetOpen: (v: boolean) => void;
}

export const useUi = create<UiState>((set) => ({
  isCouponSheetOpen: false,
  setCouponSheetOpen: (v) => set({ isCouponSheetOpen: v }),
}));
